export const ANALYTICS_IDS = {
    SignUpModalSkipBtn: 'SignUpModalSkipBtn',
    SignUpModalSignUpBtn: 'SignUpModalSignUpBtn',
    SignUpModalSubmitBtn: 'SignUpModalSubmitBtn',
    SignUpModalCancelBtn: 'SignUpModalCancelBtn',
    SignUpModalActivationBtn: 'SignUpModalActivationBtn',
    InvOptionsModalSkipCancel: 'InvOptionsModalSkipCancel',
    InvOptionsModalUpdateFunds: 'SignUpModalUpdateFunds',
    ConfirmModalSaveBtn: 'ConfirmModalSaveBtn',
    ConfirmModalDontSaveBtn: 'ConfirmModalDontSaveBtn',
    ModalSavePreferencesBtn: 'ModalSavePreferencesBtn',
    SavedModalCloseBtn: 'SavedModalCloseBtn',
    SignUpAllSetModalPreferencesSubscriptionsBtn: 'SignUpAllSetModalPreferencesSubscriptionsBtn',
    SignUpAllSetModalCloseBtn: 'SignUpAllSetModalCloseBtn',
};